import PropTypes from 'prop-types';
import React from 'react';

const GridFiltersAndCategories = ({ gridHeaderDisplay }) => (
  <>
    {gridHeaderDisplay === 'filters'
      ? <div data-testid="exposed-filters">Exposed Filters Enabled</div>
      : <div>Exposed Filters</div>}
    {gridHeaderDisplay === 'filtersAndCategories'
      ? <div data-testid="exposed-filters-and-categories">Exposed Filters and Categories Enabled</div>
      : <div>Exposed Filters and Categories</div>}
  </>
);

GridFiltersAndCategories.propTypes = {
  gridHeaderDisplay: PropTypes.string.isRequired,
};

export default GridFiltersAndCategories;
